import { Fragment } from 'react';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { ErrorAlert } from './ErrorAlert';
import { Recipients } from './Recipients';
import { SendButton } from './SendButton';
import { Settings } from './Settings';
import { useEsigning } from '../../EsigningProvider';
import { SectionContent, SectionFooter } from '../../components';
import { ActivityTab } from '../ActivityTab';
import { CreatingState } from '../CreatingState';
import { SidebarTabs } from '../SidebarTabs';
import { AlertsContainer } from './styled';
export function FormState() {
    const { submittingCreation } = useEsigning();
    const { properties: providerProperties } = useEsigningProviderMetadata();
    const { canUseSigningOrder, canUseEsigningMessages } = providerProperties;
    const isSettingsAvailable = canUseSigningOrder || canUseEsigningMessages;
    return (<Fragment>
      {submittingCreation && <CreatingState overlay polling={false}/>}
      <SectionContent>
        <AlertsContainer>
          <ErrorAlert />
        </AlertsContainer>
        <SidebarTabs recipients={<Recipients />} activity={<ActivityTab />} settings={isSettingsAvailable && <Settings />}/>
      </SectionContent>
      <SectionFooter>
        <SendButton />
      </SectionFooter>
    </Fragment>);
}
